import { useMutation, useQueryClient } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import { allocationService } from '../services/allocationService';
import type { BatchAllocationTagsRequest, BatchAllocationTagsResult } from '../types/Tag';

export function useBatchAllocationTags() {
  const qc = useQueryClient();
  return useMutation<BatchAllocationTagsResult, unknown, BatchAllocationTagsRequest>({
    mutationFn: (request) => allocationService.batchUpdateTags(request),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: allocationQueries.lists() });
      qc.invalidateQueries({ queryKey: allocationQueries.timelines() });
      qc.invalidateQueries({ queryKey: allocationQueries.checks() });
    },
  });
}
